import {eTipoPermissao} from '@/enums/ePermissoes';
export default [
 {
  description: 'Lista de Inventário',
  path: '/patrimonio/patgrupobem',
  name: 'patgrupobem',
  component: () => import('@/views/patrimonio/patgrupobem/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.LISTADEINVENTARIONOVO_MENU_1200300199],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Lista de Inventário',
  path: '/patrimonio/patgrupobem/cadastro/:id?',
  parent: 'patgrupobem',
  name: 'patgrupobem_create',
  component: () => import('@/views/patrimonio/patgrupobem/InclusaoEdicao.vue'),
  meta: {
   permissions: [eTipoPermissao.LISTADEINVENTARIONOVO_MENU_1200300199],
  },
  goesToMenu: true,
 },
]
